var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('a-divider',[_c('span',{staticStyle:{"font-size":"14px"},on:{"click":_vm.click}},[_vm._v("\n      查看更多\n      "),_c('a-icon',{attrs:{"type":"right"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }